import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GassClaims } from './auth/gass-claims';
import { checkRouteClaims } from './auth/identity.guard';
import { AuditComponent } from './features/audit/audit.component';
import { ClassificheInScadenzaComponent } from './features/classifiche-in-scadenza/classifiche-in-scadenza.component';
import { ElenchiComponent } from './features/elenchi/elenchi.component';
import { ErrorlogsComponent } from './features/errorlogs/errorlogs.component';
import { EvidenzeComponent } from './features/evidenze/evidenze.component';
import { GestioneClassQualComponent } from './features/gestione-class-qual/gestione-class-qual.component';
import { GestioneIndirizziComponent } from './features/gestione-indirizzi/gestione-indirizzi.component';
import { GestionePosizioniComponent } from './features/gestione-posizioni/gestione-posizioni.component';
import { GestioneProdottiSoftwareComponent } from './features/prodotti-software/gestione-prodotti-software.component';
import { GestioneUtentiComponent } from './features/gestione-utenti/gestione-utenti.component';
import { HomeComponent } from './features/home/home.component';
import { NuovoComponent } from './features/nuovo/nuovo.component';
import { RegistriComponent } from './features/registri/registri.component';
import { ReindexComponent } from './features/reindex/reindex.component';
import { RicercaComponent } from './features/ricerca/ricerca.component';
import { StampaEtichettaComponent } from './features/stampe/stampa-etichetta.component';
import { StatisticheComponent } from './features/statistiche/statistiche.component';
import { VisualizzaComponent } from './features/visualizza/visualizza.component';
import { DistruzioneMassivaComponent } from './features/operazioni-massive/distruzione/distruzione-massiva.component';
import { RicercaOperazioniMassiveComponent } from './features/operazioni-massive/ricerca/ricerca.component';
import { PassaggioConsegneComponent } from './features/passaggio-consegne/passaggio-consegne.component';
import { DeclassificaMassivaComponent } from './features/operazioni-massive/declassifica/declassifica-massiva.component';
import { VersamentiMassivaComponent } from './features/operazioni-massive/versamenti/versamenti-massiva.component';
import { PromemoriaComponent } from './features/promemoria/promemoria.component';

export function buildClaims(...claims: GassClaims[]): string {
  return claims.join(',');
}

const routes: Routes = [
  {
    path: '', component: HomeComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Home',
    data: { breadcrumb: 'Home', expectedClaim: buildClaims(GassClaims.DocConsultazione, GassClaims.DocModifica, GassClaims.DocAnnullamento, GassClaims.DocRiapertura, GassClaims.DocDistruzione, GassClaims.StampaAllegati, GassClaims.StampaRegistri, GassClaims.AnagIndirizzi, GassClaims.AnagClassQualSez, GassClaims.AnagFascicoli, GassClaims.AnagUtenti, GassClaims.Audit) }
  },
  {
    path: 'nuovo', component: NuovoComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Nuovo',
    data: { breadcrumb: 'Nuovo', expectedClaim: buildClaims(GassClaims.DocModifica) }
  },
  {
    path: 'nuova-partenza', component: NuovoComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Nuovo',
    data: { breadcrumb: 'Nuovo', expectedClaim: buildClaims(GassClaims.DocModifica) }
  },
  {
    path: 'nuovo-in-fascicolo', component: NuovoComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Nuovo',
    data: { breadcrumb: 'Nuovo', expectedClaim: buildClaims(GassClaims.DocModifica) }
  },
  {
    path: 'trasmetti-riproduzione', component: NuovoComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Nuovo',
    data: { breadcrumb: 'Nuovo', expectedClaim: buildClaims(GassClaims.DocModifica) }
  },
  {
    path: 'trasmetti-originali', component: NuovoComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Nuovo',
    data: { breadcrumb: 'Nuovo', expectedClaim: buildClaims(GassClaims.DocModifica) }
  },
  {
    path: 'ricerca', component: RicercaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], runGuardsAndResolvers: 'always', title: 'Ricerca',
    data: { breadcrumb: 'Ricerca', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'ricerca/:posizione', component: RicercaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], runGuardsAndResolvers: 'always', title: 'Ricerca',
    data: { breadcrumb: 'Ricerca', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'gestione-indirizzi', component: GestioneIndirizziComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Gestione Soggetti',
    data: { breadcrumb: 'Gestione Soggetti', expectedClaim: buildClaims(GassClaims.AnagIndirizzi) }
  },
  {
    path: 'evidenze', component: EvidenzeComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Evidenze',
    data: { breadcrumb: 'Evidenze', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'elenchi', component: ElenchiComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Elenchi',
    data: { breadcrumb: 'Elenchi', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'registri', component: RegistriComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Registri',
    data: { breadcrumb: 'Registri', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'classifiche-in-scadenza', component: ClassificheInScadenzaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Classifiche in scadenza',
    data: { breadcrumb: 'Classifiche in scadenza', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'statistiche', component: StatisticheComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Statistiche',
    data: { breadcrumb: 'Statistiche', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'gestione-fascicoli', component: GestionePosizioniComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Gestione fascicoli',
    data: { breadcrumb: 'Gestione fascicoli', expectedClaim: buildClaims(GassClaims.AnagFascicoli) }
  },
  {
    path: 'prodotti-software', component: GestioneProdottiSoftwareComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Prodotti software',
    data: { breadcrumb: 'Prodotti software', expectedClaim: buildClaims(GassClaims.AnagFascicoli) }
  },
  {
    path: 'gestione-classifiche', component: GestioneClassQualComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Gestione classifiche, qualifiche e sezioni',
    data: { breadcrumb: 'Gestione classifiche, qualifiche e sezioni', expectedClaim: buildClaims(GassClaims.AnagClassQualSez) }
  },
  {
    path: 'gestione-utenti', component: GestioneUtentiComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Gestione utenti',
    data: { breadcrumb: 'Gestione utenti', expectedClaim: buildClaims(GassClaims.AnagUtenti) }
  },
  {
    path: 'audit', component: AuditComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Audit',
    data: { breadcrumb: 'Audit', expectedClaim: buildClaims(GassClaims.Audit) }
  },
  {
    path: 'visualizza/:id', component: VisualizzaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Visualizza',
    data: { expectedClaim: buildClaims(GassClaims.DocConsultazione) }
  },
  {
    path: 'stampa-etichetta/:id', component: StampaEtichettaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Stampa etichetta',
    data: { expectedClaim: buildClaims(GassClaims.DocConsultazione), standalone: true }
  },
  {
    path: 'errorlogs', component: ErrorlogsComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Log errori',
    data: { breadcrumb: 'Log errori', expectedClaim: buildClaims(GassClaims.Audit) }
  },
  {
    path: 'reindex', component: ReindexComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Reindicizzazione',
    data: { breadcrumb: 'Reindicizzazione', expectedClaim: buildClaims(GassClaims.Audit) }
  },
  {
    path: 'promemoria', component: PromemoriaComponent, pathMatch: 'full', title: 'Promemoria',
    data: { breadcrumb: 'Promemoria' }
  },
  {
    path: 'operazioni', canActivate: [checkRouteClaims], title: 'Operazione Massive',
    data: { breadcrumb: 'Operazioni Massive', expectedClaim: buildClaims(GassClaims.DocConsultazione) },
    children : [
      {
        path: '', component: RicercaOperazioniMassiveComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Operazione Massive - Ricerca',
        data: { breadcrumb: 'Ricerca', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
      },
      {
        path: 'distruzione', component: DistruzioneMassivaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Operazione Massive - Distruzione Documenti',
        data: { breadcrumb: 'Distruzione Documenti', expectedClaim: buildClaims(GassClaims.DocDistruzione) }
      },
      {
        path: 'versamenti', component: VersamentiMassivaComponent, pathMatch: 'full', canActivate: [checkRouteClaims], title: 'Operazione Massive - Versamenti Documenti',
        data: { breadcrumb: 'Versamenti Documenti', expectedClaim: buildClaims(GassClaims.DocModifica) }
      },
      {
        path: 'declassifica', component: DeclassificaMassivaComponent, pathMatch: 'full',canActivate: [checkRouteClaims], title: 'Operazione Massive - Declassifica Documenti',
        data: { breadcrumb: 'Declassifica Documenti', expectedClaim: buildClaims(GassClaims.DocModifica) }
      },
      {
        path: 'ricerca', component: RicercaOperazioniMassiveComponent, pathMatch: 'full',canActivate: [checkRouteClaims], title: 'Operazione Massive - Ricerca',
        data: { breadcrumb: 'Ricerca', expectedClaim: buildClaims(GassClaims.DocConsultazione) }
      }
    ]
  },
  {
     path: 'passaggio', component: PassaggioConsegneComponent, canActivate: [checkRouteClaims], title: 'Passaggio di Consegne',
     data: { breadcrumb: 'Passaggio di Consegne', expectedClaim: buildClaims(GassClaims.PassaggioConsegne) }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
